// extracted by mini-css-extract-plugin
module.exports = {"container":"FollowUpResultsPDFStyles_container__W35yW","text":"FollowUpResultsPDFStyles_text__39m00","buttons":"FollowUpResultsPDFStyles_buttons__nwQI8"};